import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

/**
 * PackageVersionCTAMetadataLoading renders the loading UI for the
 * package version CTA metadata section.
 */
const PackageVersionCTAMetadataLoading: VoidFunctionComponent = () => (
  <div className="margin-top-md">
    <ContentLoader width="100%" height="60px" backgroundOpacity={0.4}>
      <rect x="0" y="5" rx="3" ry="3" width="25%" height="10" />
      <rect x="0" y="25" rx="3" ry="3" width="55%" height="14" />
      <rect x="0" y="52" rx="3" ry="3" width="10%" height="8" />
      <rect x="13%" y="52" rx="3" ry="3" width="25%" height="8" />
      <rect x="40%" y="52" rx="3" ry="3" width="10%" height="8" />
    </ContentLoader>
  </div>
);

export default PackageVersionCTAMetadataLoading;
